import type { ReactNode } from 'react';

type Variant = 'success' | 'error' | 'info' | 'warning';

interface SparkMessageProps {
  variant: Variant;
  children: ReactNode;
}

/** The inline status line Spark shows above a form. */
export function SparkMessage({ variant, children }: SparkMessageProps) {
  return (
    <div className={`spark-message spark-message--${variant}`} role={variant === 'error' ? 'alert' : 'status'}>
      <span className="spark-message__icon" aria-hidden="true">
        {variant === 'success' ? <CheckIcon /> : <AlertIcon />}
      </span>
      <p className="spark-message__content">{children}</p>
    </div>
  );
}

function CheckIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
      <path d="M4 12.5l5.2 5.2L20 7" />
    </svg>
  );
}

function AlertIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <circle cx="12" cy="12" r="9.2" />
      <path d="M12 7.3v6" strokeLinecap="round" />
      <circle cx="12" cy="16.6" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}
